export default "__VITE_ASSET___YyOqXBm__"